import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WhatshotIcon(props: IconProps) {
    return <Icon {...props} iconKey={"whatshot"}/>
}
